import { AlwaysAnimatedMaterialOptions } from "@/types";
import { FrontSide, MeshPhysicalMaterial } from "three";

const remapValue = (value: number, inMin: number, inMax: number, outMin: number, outMax: number) => {
	return ((value - inMin) / (inMax - inMin)) * (outMax - outMin) + outMin;
};

export const TubeMaterial = async (targetColor: number[], transparent: boolean = false) => {
	const uniforms = {
		time: { value: 0 },
		maskThreshold: { value: 0.5 },
		colorTransition: { value: 0.6 },
		targetColor: { value: targetColor },
	};

	const material = new MeshPhysicalMaterial({
		roughness: 0, // .3
		metalness: 0.3, // 0
		thickness: 0.2, // 1.2
		ior: 1, // 1.3
		//reflectivity: 2,
		dispersion: 5, // 10
		iridescence: 1.0, // 4.0
		iridescenceIOR: 1.25, // 1.3,
		depthWrite: false, // false
		clearcoat: 0.5, // 1
		clearcoatRoughness: 0, // .1

		opacity: 1, // 1
		transmission: transparent ? 1 : 0, // 1
		transparent: true,
		side: FrontSide, // DoubleSide
		iridescenceThicknessRange: [1, 1000], // [100,400]
	});

	// if (!transparent) {
	// 	//@ts-expect-error Material kann ein MeshStandardMaterial sein
	// 	material = new MeshStandardMaterial({ transparent: true });
	// }

	material.onBeforeCompile = (shader) => {
		shader.uniforms.time = uniforms.time;
		shader.uniforms.maskThreshold = uniforms.maskThreshold;
		shader.uniforms.colorTransition = uniforms.colorTransition;
		shader.uniforms.targetColor = uniforms.targetColor;

		shader.vertexShader = shader.vertexShader.replace(`void main() {`, `varying vec2 vUv; void main() {`);

		shader.vertexShader = shader.vertexShader.replace(
			"#include <uv_vertex>",
			`
		   #include <uv_vertex>
		   vUv = uv;
		   `
		);

		shader.fragmentShader = `
		  varying vec2 vUv;
		  uniform float maskThreshold;
		  uniform float colorTransition;
		  uniform vec3 targetColor;

		  ${shader.fragmentShader}
		`;

		shader.fragmentShader = shader.fragmentShader.replace(
			"#include <map_fragment>",
			`
		    #include <map_fragment>
		    // Berechnung der Maske
		    float mask = smoothstep(maskThreshold - 0.1, maskThreshold + 0.1, vUv.x);

		    // Alpha-Animation
		    diffuseColor.a *= (1.0 - mask);

		    // Farb-Animation: Übergang zur Ziel-Farbe
		    float colorMask = clamp( smoothstep(colorTransition, colorTransition, vUv.x) , 0.0,1.0);

		    // Mische zwischen aktueller Farbe und Ziel-Farbe
		    diffuseColor.rgb = mix(diffuseColor.rgb, targetColor, colorMask);
		    `
		);
	};

	material.userData.always_animated = (opt: AlwaysAnimatedMaterialOptions) => {
		const animationTime = 0.5 + Math.sin(opt.clock.getElapsedTime()) * 0.5;
		const percentage = 0.3;
		// Alpha-Animation von 0 bis percentage
		uniforms.maskThreshold.value = remapValue(Math.min(percentage, animationTime), 0.0, percentage, 0, 0.9);
		// Farb-Animation von percentage bis 1.0
		uniforms.colorTransition.value = 1 - remapValue(Math.max(percentage, animationTime), percentage, 0.7, 0, 0.9);
	};

	return material;
};
